import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { Action, Store } from '@ngrx/store'
import { ButtonComponent } from '../button/button.component'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'mcm-warning-modal',
  templateUrl: './warning-modal.component.html',
  styleUrls: ['./warning-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, TranslatePipe]
})
export class WarningModalComponent {
  private readonly _store: Store = inject(Store)
  title: string
  body: string
  actionClose: () => Action

  onClose() {
    this._store.dispatch(this.actionClose())
  }
}
